import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const useTillReturnBackGuard = ({ active, backTo }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!active || !backTo) return;

    const current = window.history.state || {};
    const nextState = typeof current.idx === "number" ? { ...current, idx: current.idx + 1 } : current;
    window.history.pushState(nextState, "", window.location.href);

    const onPopState = () => navigate(backTo, { replace: true });
    window.addEventListener("popstate", onPopState);

    return () => window.removeEventListener("popstate", onPopState);
  }, [active, backTo]);
};
